export default __webpack_public_path__ + "static/media/national-green-infrastructure-conclave-2024.93c1b539.jpg";